import React from 'react';
import PropTypes from 'prop-types';

import { KeyboardTimePicker as MUIKeyboardTimePicker } from '@material-ui/pickers';

export const KeyboardTimePicker = props => <MUIKeyboardTimePicker {...props} />;

KeyboardTimePicker.propTypes = {
  DialogProps: PropTypes.object,
  KeyboardButtonProps: PropTypes.object,
  ampm: PropTypes.bool,
  autoOk: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.node,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  keyboardIcon: PropTypes.node,
  label: PropTypes.node,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  mask: PropTypes.string,
  onAccept: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object
};

export default KeyboardTimePicker;
